import { combineReducers } from '@reduxjs/toolkit';
import AuthSlice from './AuthSlice';
import VehicleSlice from './VehicleSlice';
import ProfileSlice from './ProfileSlice';
import AttachmentSlice from './AttachmentSlice';
import DocumentSlice from './DocumentSlice';
import UsersSlice from './UsersSlice';
import LocationSlice from './LocationSlice';
import TripSlice from './TripSlice';
import PlacesSlice from './PlacesSlice';
import ToursSlice from './ToursSlice';
import CustomerOnCallSlice from './CustomerOnCallSlice';
import DriverOnCallSlice from './DriverOnCallSlice';
import CustomerSupport from './CustomerSupport';

export default combineReducers({
  auth: AuthSlice,
  vehicle: VehicleSlice,
  profile: ProfileSlice,
  attach: AttachmentSlice,
  docs: DocumentSlice,
  users: UsersSlice,
  location: LocationSlice,
  trip: TripSlice,
  place: PlacesSlice,
  tours: ToursSlice,
  customerOnCall: CustomerOnCallSlice,
  driverOnCall: DriverOnCallSlice,
  faq: CustomerSupport,
});
